<template>
  <section class="app-docs flex w-full">
    <CommonDocumentMenu
      v-model:active-tab="tabValue"
      :catalog="currentData"
      :prefix-path="`/${$route.params.lang}/docs`"
      :tab-list="tabsData"
      open-obsoleted-btn
    />
    <section class="app-docs-inner">
      <NuxtPage />
    </section>
  </section>
</template>
<script lang="ts" setup>
import { CatalogsConfig, TabConfig } from '~/components/gfr/types/components'
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-index-page-cache-tag'])
})
const { formatTransify } = useStore()
const documentStore = useDocumentStore()
const { fetchCategoryList, fetchModuleList, updateActivePath } = documentStore
const { moduleData, typeData } = storeToRefs(documentStore)
await fetchModuleList()
await fetchCategoryList()
const route = useRoute()
const tabValue = ref('type')
const tabsData = ref<TabConfig[]>([
  {
    label: formatTransify('UGC_OFFICIAL_WEBSITE_MODULES'),
    value: 'module'
  },
  {
    label: formatTransify('UGC_OFFICIAL_WEBSITE_TYPE'),
    value: 'type'
  }
])
// 根据Tab切换或搜索获取指定的数据
const currentData = computed(() => {
  return tabValue.value !== 'type' ? moduleData.value : typeData.value
})
const findFirstArticle = (arr: CatalogsConfig[], key = 'url'): CatalogsConfig | undefined => {
  for (const item of arr) {
    if (item[key as keyof CatalogsConfig]) {
      return item
    } else if (item.children) {
      return findFirstArticle(item.children, key)
    }
  }
  return undefined
}
const firstTypeArticle = computed(() => {
  return findFirstArticle(typeData.value)
})
/* no route.params.id, navigate to first document of current category */
if (!route.params.id) {
  firstTypeArticle.value?.url && navigateTo(`/${route.params.lang}/docs/${firstTypeArticle.value?.url}`)
}
const findTabLabel = (value: string) => {
  return tabsData.value.find((tab) => tab.value === value)?.label || ''
}
/* --- init --- */
const init = (value: string = String(route.params.id)) => {
  const founded = updateActivePath(
    typeData.value,
    'url',
    value,
    { title: findTabLabel('type') },
    () => (tabValue.value = 'type')
  )

  if (!founded) {
    updateActivePath(
      moduleData.value,
      'url',
      value,
      { title: findTabLabel('module') },
      () => (tabValue.value = 'module')
    )
  }
}
init()
watch(
  () => route.params.id,
  (value) => {
    if (!value) {
      firstTypeArticle.value?.url && navigateTo(`/${route.params.lang}/docs/${firstTypeArticle.value?.url}`)
    }
    init(String(value))
  }
)
</script>
<style lang="scss" scoped>
.app-docs-inner {
  @apply 2xl:max-w-[calc(100%-380px)] max-2xl:max-w-[calc(100%-352px)] flex-1 pt-3 max-lg:w-full max-lg:max-w-full max-lg:pr-0  max-2xl:pr-5 lg:pt-6;
  @apply rtl:2xl:pl-15 ltr:2xl:pr-15;
}
</style>
